import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Group, IntOperator, WorkflowCard } from 'routes/screens/wflow/styles';
import { ActionButton } from 'routes/styles';
import Icon from 'shared/components/Icon';
import { WorkflowType } from 'shared/types';
import { NUMBER_OF_ALLOWED_ACTIONS } from '../../constants';
import Action from './action';

type WorkflowActionProps = {
  id?: string;
  disabled: boolean;
};

const WorkflowAction = (props: WorkflowActionProps) => {
  const { disabled } = props;
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<WorkflowType>();

  const actions = watch('actions');
  const event = watch('event');
  const trigger = watch('type');

  const onAddAction = () => {
    const newActions = [...(actions || [])];
    newActions.push({});
    setValue('actions', newActions);
  };

  const onDeleteAction = (actionIndexToDelete) => {
    const newActions = [...(actions || [])].filter(
      (a, index) => actionIndexToDelete !== index,
    );
    setValue('actions', newActions);
  };

  return (
    <WorkflowCard>
      <div className="wf-title">{`${
        trigger === 'AUTOMATIC'
          ? event === 'EVERYTIME_A_CONTACT_IS_UNSUBSCRIBED'
            ? '2.'
            : '3.'
          : ''
      }${t('workflow.create.perform_action') || ''}`}</div>
      <div className="wf-description">{t('workflow.all_action_types')}</div>
      {actions?.map((action, index) => (
        <>
          <Group key={action.id}>
            <div className="wf-action-group">
              <ActionButton
                className={disabled || actions.length === 1 ? 'disabled' : ''}
                onClick={() => {
                  if (disabled || actions.length === 1) return;
                  onDeleteAction(index);
                }}
              >
                <div>
                  <Icon width="12" height="12" glyph="minus" />
                </div>
              </ActionButton>
              <div className="wf-row" style={{ alignItems: 'baseline' }}>
                <Action actionIndex={index} disabled={disabled} />
              </div>
            </div>
          </Group>
          {index < (actions || []).length - 1 && (
            <IntOperator>{t('and')}</IntOperator>
          )}
        </>
      ))}
      <ActionButton
        onClick={onAddAction}
        className={
          disabled || (actions && actions?.length >= NUMBER_OF_ALLOWED_ACTIONS)
            ? 'disabled'
            : ''
        }
      >
        <div>
          <Icon width="12" height="12" glyph="plus" />
        </div>
        <div>{`${t('workflow.action.new_action')}`}</div>
      </ActionButton>
    </WorkflowCard>
  );
};

export default WorkflowAction;
